import React, { useEffect, useState } from "react";
import { useGet } from "../../services/hooks/useGet";
import { configWithToken, GetUrl } from "../../api/endpointConfig";
import { useLoader } from "../../Loader/LoaderContext";


const useDashboard = () => {
    const { showLoader, hideLoader } = useLoader();
    const { data=[], isLoading, isError } = useGet<any>(
    `${GetUrl.getDashboard}`,
    configWithToken
    );

      useEffect(() => {
        if(isLoading && !isError) {
          showLoader()
        } else if(isError){ hideLoader()}
          else {hideLoader()}
      },[isLoading, isError])

    return {data, isLoading, isError }

}

export default useDashboard